import { GameVars } from "../../GameVars";
import { BoardScene } from "./BoardScene";
import * as Carrom from "carrom-king-engine";

export class MessagesManager {

    constructor() {
        //
    }

    public onNewTurn(firstTurn?: boolean): void {

        if (firstTurn) {
            BoardScene.currentInstance.showMessage(Messages.FIRST_TURN);
        } else {

            if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
                BoardScene.currentInstance.showMessage(Messages.TURN_CHANGE);
            } else {

                if (!GameVars.turnData) {
                    BoardScene.currentInstance.showMessage(Messages.SKIPPED_TURN);
                } else if (GameVars.turnData && GameVars.turnData.faults.length > 0) {

                    const faults = GameVars.turnData.faults;

                    if (faults.indexOf(Carrom.Fault.STRIKER_POCKETED) !== -1) {
                        BoardScene.currentInstance.showMessage(Messages.STRIKER_POCKETED);
                        return;
                    }
                } 
            }
        }
    }

    public showMessage(messageType: string): void {

        BoardScene.currentInstance.showMessage(messageType);
    }
}
